export const GET_CATEGORIES = 'CATEGORY/get_category';
export const SHOW_CATEGORY = 'CATEGORY/show_category';
export const CREATE_CATEGORY = 'CATEGORY/create_category';
export const UPDATE_CATEGORY = 'CATEGORY/update_category';
export const REMOVE_CATEGORY = 'CATEGORY/remove_category';

export const FORM_DATA = {
  code: '',
  name: '',
  is_active: 0,
};
